module.exports = __webpack_public_path__ + "assets/images/4655237e06a6fcf48194eee3371cf302.jpg";